module.exports = __webpack_public_path__ + "static/media/red-circle.9571d7ea.svg";